import 'react-app-polyfill/stable'
// Must load before Bugsnag and the trackers: it removes login_token from the URL.
import './app/services/urlLoginToken'

import { BUGSNAG } from 'app/constants/Bugsnag'
import * as React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import App from './app/App'
import initHeapAnalytics from './app/config/HeapAnalytics'
import NotifierProvider from './app/lib/contexts/Notifier'
import configureStore from './app/redux/store'
import PushNotificationService from './app/services/PushNotificationService'
import ScriptService from './app/services/ScriptService'

const rootEl = document.getElementById('app-site') || document.createElement('div')

export const store = configureStore()
export type AppDispatch = typeof store.dispatch

const unsubscribe = store.subscribe(subscription)

initHeapAnalytics()

function subscription() {
  const { user, contact, contactOrganizations } = store.getState().user
  if (user) {
    const { hubspot_sync, email, id } = user
    PushNotificationService.init(id)
    ScriptService.initServiceWorker()
    ScriptService.initMouseflow(email)
    ScriptService.initGoogleTagManager()
    ScriptService.embedHubspotScript(email, hubspot_sync)
    BUGSNAG.setUser(id, email)

    window.heap?.addUserProperties({
      ...contact,
      ...user,
      customer_organization_name: contactOrganizations
        .map((org: IContactOrganization) => org.name)
        .join(', '),
      role: contactOrganizations.map((org: IContactOrganization) => org.role).join(', ')
    })

    unsubscribe()
  }
}

export const ErrorBoundary = BUGSNAG.getPlugin('react').createErrorBoundary(React)

render(
  <Provider store={store}>
    <ErrorBoundary>
      <BrowserRouter>
        <NotifierProvider>
          <App />
        </NotifierProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>,
  rootEl
)
